export const convertUrlToBlob = async (url) => {
  return await fetch(url).then((r) => r.blob());
};

export const convertUrlToFile = async (url, name, type) => {
  console.log(name);
  console.log(type);
  return await fetch(url)
    .then((r) => r.blob())
    .then((blobFile) => new File([blobFile], name, { type: type }));
};
